import { CoverPageHashSection, CoverPageHashSectionKey } from "./types"

export const COVER_PAGE_PADDING = {
  base: "30px",
  md: "50px"
}

export const COVER_PAGE_PANEL_PAGE_SIZE = 50
export const COVER_PAGE_PANEL_SEARCH_DEBOUNCE_MS = 250

export const COVER_PAGE_PANEL_ROOT_KEY = "cover"

export const COVER_PAGE_HASH_SECTION_KEYS = Object.values(
  CoverPageHashSection
) as CoverPageHashSectionKey[]

export const COVER_PAGE_SECTION_SCROLL_OFFSET = 150
export const COVER_PAGE_HIGHLIGHT_DURATION_MS = 1100
export const COVER_PAGE_HASH_RETRY = {
  maxAttempts: 20,
  intervalMs: 50
} as const

/** How far into the smooth scroll the section emphasis starts fading in. */
export const COVER_PAGE_SCROLL_EMPHASIS = {
  progress: 0.65,
  maxWaitMs: 1200
} as const
